const digest = '4e3b3efd6b73fad1c53d3e545708ea8b958b41ba4f0b2bf1d124904bba5e5052';
const css = `._touchTarget_xcmb4_1{align-items:center;border-radius:4px;display:inline-flex;position:relative}._touchTarget_xcmb4_1:after{border-radius:inherit;content:"";height:max(100%,44px);left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:max(100%,44px)}._touchTarget_xcmb4_1:focus-visible{outline:none}._touchTarget_xcmb4_1:focus-visible:after{box-shadow:0 0 0 1px #006fcf}._termsLink_xcmb4_27 [data-dls-icon-size=xs]{align-items:flex-start;display:inline-flex;margin-bottom:4px;transform:translateY(-1px)}._termsLink_xcmb4_27 [data-dls-icon-size=xs] svg{display:block}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'touchTarget': '_touchTarget_xcmb4_1', 'termsLink': '_termsLink_xcmb4_27' };
export const touchTarget = '_touchTarget_xcmb4_1';
export const termsLink = '_termsLink_xcmb4_27';
export { css, digest };